import { Box, LinearProgress, Stack } from "@mui/material";
// import Grid2 from "@mui/material/Grid";
import orderBy from "lodash.orderby";
import React from "react";

export default function BarChart({
  data,
  percentage,
  ordered,
  doNotShowZeros,
  color,
  backgroundColor,
}) {
  let dataValueDivisor = 1;
  let processedData = data;
  if (ordered) {
    processedData = orderBy(data, "value", "desc");
  }
  if (percentage) {
    processedData.forEach((element) => {
      if (dataValueDivisor < element.value) {
        dataValueDivisor = element.value;
      }
    });
  }

  console.log("processedData", processedData);
  return (
    <Box className="p-0">
      {processedData &&
        processedData.map((item) => {
          if (!(doNotShowZeros && item.value === 0)) {
            return (
              <div className="px-0 py-1 mb-4" key={item.key}>
                <div className="pb-2 flex justify-between">
                  <p style={{ display: "inline" }}>{item.label}</p>
                  <h3 style={{ display: "inline", paddingLeft: "1rem" }}>
                    {item.value}
                  </h3>
                </div>
                <LinearProgress
                  sx={{
                    backgroundColor: backgroundColor ?? "rgb(167, 202, 237)",
                    borderRadius:5,
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: color ?? "#1976d2",
                      borderRadius:5,
                    },
                  }}
                  variant="determinate"
                  value={
                    !percentage
                      ? item.value
                      : (item.value / dataValueDivisor) * 100
                  }
                />
              </div>
            );
          }
        })}
    </Box>
  );
}
